import styled from 'styled-components';

export const StyledDrawerList = styled.div`
  background-color: ${(p) => p.theme.alias.bg};
  width: 240px;
  padding: ${(p) => p.theme.space[3]} 0;
  display: flex;
  flex-direction: column;
`;
